import { ChartTypeConfig } from './ChartTypeConfig';
import { SeriesType } from '../utils/SeriesType';
import { BasicChart, SeriesOption } from '../utils/models';
import { ChartConfig } from './ChartConfig';

export class ColumnChartConfig extends ChartConfig implements ChartTypeConfig {
    getConfig(categories: string[], data: SeriesOption[], colors: string[]): Partial<BasicChart> {

        const series = data.map((seriesData, index) => ({
            ...seriesData,
            name: seriesData.name,
            type: SeriesType.Bar,
            label: {
                show: true,
                position: seriesData.label.position ?? 'top',
                formatter:
                    seriesData.label?.formatter ??
                    ((params) => {
                        const val = Number(params.value);
                        return val && val !== 0 ? `${val.toFixed(1)}%` : '';
                    })
            },
            itemStyle: {
                color: seriesData.itemStyle?.color ?? colors[index % colors.length]
            },
            data: (seriesData.data ?? []).map((point: any) => {
                if (point.value)
                    return {
                        ...point,
                        itemStyle: {
                            ...point.itemStyle,
                            borderRadius: seriesData.stack == 'total' ? '' : (point.value > 0) ? [8, 8, 0, 0] : [0, 0, 8, 8],
                        }
                    }

                return {
                    value: point,
                    itemStyle: {
                        borderRadius: seriesData.stack == 'total' ? '' : (point > 0) ? [8, 8, 0, 0] : [0, 0, 8, 8],
                    }
                }
            }),
            barMaxWidth: 100

        })) as SeriesOption[];

        return {
            xAxis: {
                type: 'category',
                data: categories,
                max: undefined,
                axisLabel: { formatter: null }
            },
            yAxis: {
                type: 'value',
                data: undefined,
                axisLine: { show: true },
                splitLine: { show: true },
                axisLabel: { formatter: (value) => value + '%' }
            },
            series
        };
    }
}
